<template>
  <div class="base-text-field form-group">
    <div
      class="px-0"
      :class="`col-${col}`">
      <b-form-input
        :class="fieldClass"
        :value="_value"
        :name="name"
        :placeholder="placeholder"
        :type="type"
        :disabled="disabled"
        :autocomplete="autocomplete"
        v-on="customListeners" />
    </div>
    <BaseErrorMessage
      :color="errorTextColor"
      :errors="errors" />
  </div>
</template>

<script>
import BaseErrorMessage from '@/components/parts/BaseErrorMessage.vue'
export default {
  name: 'BaseTextField',
  components: {
    BaseErrorMessage
  },
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    errors: {
      type: Array,
      default: () => []
    },
    errorTextColor: {
      type: String,
      default: 'primary'
    },
    col: {
      type: [String, Number],
      default: 12
    },
    type: {
      type: String,
      default: 'text' 
    },
    name: {
      type: String,
      default: undefined
    },
    placeholder: {
      type: String,
      default: undefined
    },
    emptyStrToNull: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fieldClass: {
      type: String,
      default: null
    },
    autocomplete: {
      type: String,
      default: undefined
    }
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(v) {
        return this.$emit('input', v)
      }
    },
    customListeners() {
      return {
        ...this.$listeners,
        input: this.onInput,
      }
    }
  },
  methods: {
    onInput(input) {
      if (input !== '') {
        this.$emit('input', input)
        return
      }

      this.$emit('input', this.emptyStrToNull ? null : input)
    }
  }
}
</script>

<style lang="scss" scoped>
.base-text-field {
  width: 100%;
  margin-bottom: 0;
}
</style>